import { Map } from 'immutable';

import * as t from '../actions/mainActionTypes';

const initialState = Map({
  showMobileMenu: false,
});

const reducer = function mainReducer(state = initialState, action) {
  switch (action.type) {
    case t.SET_SHOW_MOBILE_MENU:
      return state.set('showMobileMenu', action.show);

    default:
      return state;
  }
};

export default reducer;
